import { useFragment } from '@apollo/client';

import { Skeleton } from '@ui/Skeleton';
import { ProductDetailsSocialsShare } from '@components/product/ProductDetailsSocialsShare';

import { ProductDetailsSocialsShareFragment, ProductDetailsSocialsShareFragmentDoc } from './gql/graphql.v3.generated';

type Product = {
  __typename?: 'ProductDetails',
  id: number,
}

interface Props {
  className?: string,
  product?: Product,
}

export const ProductDetailsSocialsShareContainer: React.FC<Props> = ({
  className,
  product,
}) => {
  const { data, complete } = useFragment<ProductDetailsSocialsShareFragment>({
    fragment: ProductDetailsSocialsShareFragmentDoc,
    from: product || null,
  });

  if (!complete) {
    return (
      <Skeleton
        width='150px'
        height='24px'
      />
    );
  }

  if (data) {
    return (
      <ProductDetailsSocialsShare
        className={className}
        productName={data.name}
        brandName={data.brand?.name}
        price={data.price}
      />
    );
  }

  return null;
};
